import React, { useState } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { Button, Icon, List, Modal, Segment } from "semantic-ui-react";
import { AutomaticBillingResponse } from "ts-types/api.types";
import styled from "styled-components";
import PraxFormScrollableContainer from 'components/layout/PraxFormScrollableContainer';
import { getAutomaticBillingPdfUrl } from 'services/billServices';

const StyledModal = styled(Modal)`
  height: 90vh;
  width: 90vw !important;
`;

const StyledModalContent = styled(Modal.Content)`
  padding: 0 !important;
  height: 100% !important;
`;

const StyledSegmentGroup = styled(Segment.Group)`
  margin: 0 !important;
  height: 100% !important;
  border: none !important;
`;

const LeftSegment = styled(Segment)`
  width: 70% !important;
  padding: 0 !important;
`;

const RightSegment = styled(Segment.Group)`
  width: 30% !important;
  margin: 0 !important;
  border: none !important;
`;

const ListSegment = styled(Segment)`
  padding: 0 !important;
  height: 100% !important;
`;

const ButtonSegment = styled(Segment)`
  height: 8% !important;
  min-height: 50px !important;
  padding-top: 7% !important;
  padding-bottom: 6% !important;
  align-items: center;

  & button {
    float: right;
  }
`;

const ListContent = styled.div`
  width: 90%;
  display: inline-block;
  align-items: center;
`;

const DownloadSection = styled.div`
  width: 10%;
  display: inline-block;
  align-items: center;
  vertical-align: top;
`;

const StyledListItem = styled(List.Item)`
  padding: 0.75rem !important;
`;

const btnStyle = {
  background: "transparent",
  cursor: "pointer",
  padding: "5px 10px"
};

interface Props extends MessageSourceProps {
  automaticBillingResponses: Array<AutomaticBillingResponse>
  modalOpen: boolean,
  onCloseModal: () => void
}

const AutomaticBillingPdfModal = (props: Props) => {

  const {automaticBillingResponses, modalOpen, onCloseModal, getMessage} = props;

  if (!automaticBillingResponses || automaticBillingResponses.length == 0) {
    onCloseModal();
  }

  const [selectedAutmaticBillingResponse, setSelectedAutomaticBillingResponse] = useState<AutomaticBillingResponse>(automaticBillingResponses[0]);

  const pdfId = selectedAutmaticBillingResponse.pdfId;
  const pdfName = selectedAutmaticBillingResponse.pdfName;

  const automaticBillingPdfUrl: string = getAutomaticBillingPdfUrl(pdfId, pdfName);

  const mappedAutomaticBillingResponses = automaticBillingResponses.map((automaticBillingResponse, index) => (
      <StyledListItem
          key={index}
          active={selectedAutmaticBillingResponse.pdfId == automaticBillingResponse.pdfId}
          onClick={() => setSelectedAutomaticBillingResponse(automaticBillingResponse)}
      >
        <List.Icon style={{padding: "10px"}} name="file pdf outline" size="large" verticalAlign="middle"/>
        <List.Content>
          <ListContent>
            <List.Header as="h4">{automaticBillingResponse.pdfName}</List.Header>
            <List.Description as="span">{automaticBillingResponse.pdfSize}</List.Description>
          </ListContent>
          <DownloadSection>
            <Button
                as="a"
                href={getAutomaticBillingPdfUrl(pdfId, pdfName)}
                download={automaticBillingResponse.pdfName}
                icon
                style={btnStyle}
            >
              <Icon name="download" size="large"/>
            </Button>
          </DownloadSection>
        </List.Content>
      </StyledListItem>
  ));

  return (
      <StyledModal
          open={modalOpen}
          onClose={onCloseModal}
      >
        <StyledModalContent>
          <StyledSegmentGroup horizontal>
            <LeftSegment>
              <embed
                  src={automaticBillingPdfUrl}
                  width="100%"
                  height="100%"
                  type="application/pdf"
              />
            </LeftSegment>
            <RightSegment>
              <PraxFormScrollableContainer height={"92%"}>
                <ListSegment>
                  <List divided relaxed selection>
                    {mappedAutomaticBillingResponses}
                  </List>
                </ListSegment>
              </PraxFormScrollableContainer>
              <ButtonSegment>
                <Button compact
                        type="button"
                        onClick={onCloseModal}
                >
                  {getMessage("button.close")}
                </Button>
              </ButtonSegment>
            </RightSegment>
          </StyledSegmentGroup>
        </StyledModalContent>
      </StyledModal>
  );
};

export default withMessages(AutomaticBillingPdfModal);
